export default __webpack_public_path__ + "static/blockchain-104df95a8f7673d5e3ba981ba436ee74.svg";